import { render, staticRenderFns } from "./BanDescription.vue?vue&type=template&id=399284c4&"
import script from "./BanDescription.vue?vue&type=script&lang=js&"
export * from "./BanDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports